import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { GridRowModes, GridRowModesModel, GridToolbarContainer } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';

import useAdjustInvoiceContext from './useAdjustInvoiceContext';

interface EditToolbarProps {
	setRowModesModel: (newModel: (oldModel: GridRowModesModel) => GridRowModesModel) => void;
	setRows: (newRows: any) => void;
	loading: boolean;
}

export const DataGridAddBatchToolbar = ({ loading, setRows, setRowModesModel }: EditToolbarProps) => {
	const { isAdjustingEachLineItem } = useAdjustInvoiceContext();
	if (isAdjustingEachLineItem) {
		const id = v4();
		return (
			<GridToolbarContainer>
				<Button
					color='primary'
					startIcon={<AddIcon />}
					disabled={loading}
					onClick={() => {
						setRows((oldRows) => [
							{
								id,
								isNew: true,
								type: 'ADJUSTMENT',
								createdAt: ' ',
								amount: '',
								amountTax1: '',
								amountTax2: '',
								amountTax3: '',
								amountTax4: '',
							},
							...oldRows,
						]);
						setRowModesModel((oldModel) => ({
							...oldModel,
							[id]: { mode: GridRowModes.Edit },
						}));
					}}
					data-cy='add-adjustment-entry-button'
				>
					Add Adjustment Entry
				</Button>
			</GridToolbarContainer>
		);
	}

	return <div />;
};
